export const PlaidIcon = () => (
  <svg
    width="53"
    height="20"
    viewBox="0 0 53 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Plaid</title>
    <g clipPath="url(#clip0_618_173)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.103 6.77849C27.6626 6.40807 26.9109 6.22307 25.8476 6.22307H23.4492V13.6347H25.2426V11.3118H26.0459C27.0209 11.3118 27.7359 11.0972 28.1909 10.6677C28.7034 10.1864 28.9613 9.54557 28.9613 8.74557C28.9613 7.91599 28.6751 7.26016 28.103 6.77849ZM26.0013 9.63474H25.2426V7.90016H25.9242C26.7534 7.90016 27.168 8.19099 27.168 8.77266C27.168 9.34682 26.7788 9.63474 26.0013 9.63474ZM32.0301 6.22266H30.1601V13.6343H34.1976V11.9568H32.0301V6.22266ZM37.8613 6.22266L34.9238 13.6343H36.9371L37.3221 12.5568H39.8746L40.2267 13.6343H42.2626L39.3459 6.22266H37.8613ZM37.8392 11.0564L38.6096 8.52307L39.368 11.0564H37.8392Z"
        fill="#111111"
      />
      <mask
        id="mask0_618_173"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="53"
        height="20"
      >
        <path d="M0.5 19.7804H53V0H0.5V19.7804Z" fill="white" />
      </mask>
      <g mask="url(#mask0_618_173)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.1971 13.6342H45.0675V6.2225H43.1971V13.6342ZM52.3292 7.61167C52.0929 7.2691 51.7896 6.97808 51.4375 6.75625C50.8729 6.40042 50.1025 6.22292 49.1271 6.22292H46.6629V13.6342H49.5454C50.5871 13.6342 51.4229 13.2937 52.0537 12.6121C52.6846 11.9308 52.9996 11.0267 52.9996 9.90042C52.9996 9.00458 52.7762 8.24167 52.3292 7.61167ZM49.3362 11.9562H48.5333V7.90042H49.3475C49.9196 7.90042 50.3592 8.07958 50.6675 8.43667C50.9758 8.79375 51.13 9.30042 51.13 9.95625C51.13 11.2896 50.5321 11.9562 49.3362 11.9562ZM8.26542 0L2.20417 1.5875L0.53375 7.68292L2.62292 9.82792L0.5 11.9375L2.07208 18.0596L8.10708 19.7458L10.2304 17.6358L12.3196 19.7804L18.3808 18.1929L20.0508 12.0971L17.9621 9.95292L20.085 7.84333L18.5129 1.72083L12.4771 0.0345833L10.3546 2.14417L8.26542 0ZM4.54583 2.76L7.73875 1.92333L9.135 3.35667L7.09875 5.38L4.54583 2.76ZM11.555 3.37583L12.9737 1.96625L16.1529 2.85458L13.5583 5.4325L11.555 3.37583ZM2.44667 7.1825L3.32625 3.97208L5.87833 6.59208L3.8425 8.61542L2.44667 7.18208V7.1825ZM14.7579 6.66458L17.3525 4.08583L18.18 7.31083L16.7617 8.72083L14.7579 6.66458ZM8.29875 6.61167L10.335 4.58833L12.3379 6.645L10.3021 8.66833L8.29875 6.61167ZM5.04292 9.84708L7.07875 7.82375L9.08292 9.88042L7.04625 11.9037L5.04292 9.84708ZM11.5025 9.9L13.5383 7.87667L15.5417 9.93333L13.5054 11.9567L11.5025 9.9ZM2.40417 12.4696L3.82333 11.0592L5.82625 13.1162L3.2325 15.6937L2.40417 12.4696ZM8.24625 13.1354L10.2825 11.1121L12.2858 13.1687L10.25 15.1921L8.24625 13.1354ZM14.7054 13.1887L16.7417 11.1654L18.1379 12.5983L17.2587 15.8087L14.7054 13.1887ZM4.43208 16.9262L7.02625 14.3475L9.03042 16.4042L7.61125 17.8146L4.43208 16.9262ZM11.45 16.4237L13.4858 14.4004L16.0383 17.0208L12.8458 17.8571L11.45 16.4237Z"
          fill="#111111"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_618_173">
        <rect
          width="52.5"
          height="20"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
